import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CreditPreview = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration] = useState(45); // 45 seconds preview

  const mockCredits = [
    { role: "Director", name: "Sarah Johnson" },
    { role: "Producer", name: "Michael Chen" },
    { role: "Cinematographer", name: "David Rodriguez" },
    { role: "Editor", name: "Emily Watson" },
    { role: "Music Composer", name: "James Thompson" }
  ];

  const handlePlayPause = () => {
    setIsPlaying(!isPlaying);
    if (!isPlaying) {
      // Simulate video playback
      const interval = setInterval(() => {
        setCurrentTime(prev => {
          if (prev >= duration) {
            setIsPlaying(false);
            clearInterval(interval);
            return 0;
          }
          return prev + 1;
        });
      }, 1000);
    }
  };

  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs?.toString()?.padStart(2, '0')}`;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
            <Icon name="Eye" size={20} className="text-accent" />
          </div>
          <div>
            <h2 className="text-lg font-semibold text-foreground">Credit Preview</h2>
            <p className="text-sm text-muted-foreground">Preview your credit formatting</p>
          </div>
        </div>
        <Button variant="outline" size="sm" iconName="Maximize2">
          Fullscreen
        </Button>
      </div>
      {/* Preview Area */}
      <div className="relative bg-black rounded-lg overflow-hidden mb-4" style={{ aspectRatio: '16/9' }}>
        <div className="absolute inset-0 flex items-center justify-center">
          {/* Title Card Preview */}
          <div className="text-center text-white">
            <h3 className="text-2xl md:text-4xl font-bold mb-4">DIRECTOR</h3>
            <p className="text-xl md:text-2xl font-light">Sarah Johnson</p>
          </div>
        </div>

        {/* Play/Pause Overlay */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-100 transition-opacity bg-black/20">
          <Button
            variant="ghost"
            size="icon"
            onClick={handlePlayPause}
            className="w-16 h-16 bg-white/20 hover:bg-white/30 text-white"
          >
            <Icon name={isPlaying ? "Pause" : "Play"} size={24} />
          </Button>
        </div>

        {/* Progress Bar */}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent p-4">
          <div className="flex items-center space-x-3 text-white text-sm">
            <span>{formatTime(currentTime)}</span>
            <div className="flex-1 bg-white/20 rounded-full h-1">
              <div 
                className="bg-white h-1 rounded-full transition-all duration-300"
                style={{ width: `${(currentTime / duration) * 100}%` }}
              />
            </div>
            <span>{formatTime(duration)}</span>
          </div>
        </div>
      </div>
      {/* Credit List */}
      <div className="space-y-3">
        <h3 className="text-sm font-medium text-foreground">Credits to Include:</h3>
        <div className="space-y-2">
          {mockCredits?.map((credit, index) => (
            <div key={index} className="flex items-center justify-between p-3 bg-muted/50 rounded-lg">
              <div className="flex items-center space-x-3">
                <div className="w-2 h-2 bg-primary rounded-full" />
                <span className="text-sm font-medium text-foreground">{credit?.role}</span>
              </div>
              <span className="text-sm text-muted-foreground">{credit?.name}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center justify-between mt-6 pt-4 border-t border-border">
        <div className="flex items-center space-x-2 text-sm text-muted-foreground">
          <Icon name="Info" size={16} />
          <span>Preview shows first 5 credits</span>
        </div>
        <Button variant="outline" size="sm" iconName="RotateCcw">
          Restart Preview
        </Button>
      </div>
    </div>
  );
};

export default CreditPreview;